import { TemplateTitle } from 'components/organisms/document/template-title';

interface Props {
  value: string;
  onChange: (value: string) => void;
  readonly?: boolean;
}

export const MeetingDocumentHeaderTitle = ({
  value,
  onChange,
  readonly,
}: Props) => {
  return (
    <TemplateTitle value={value} onChange={onChange} readonly={readonly} />
  );
};
